import { RoutingPanelCard } from '../types'

export const createId = (card: RoutingPanelCard) => card.imageId + card.group || ''
